var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEngeneers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 15H43V35H50V15Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 23H20V35H27V23Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 20H31V35H38V20Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4924 35L15 34.5654L22.86 25.5778L28.611 30.7959L34.536 23L39.6108 28.3383L42.4321 23.4115L43 23.7407L39.7421 29.4313L34.5918 24.0123L28.6996 31.7654L22.9142 26.5144L15.4924 35Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4984 36H14.5016C14.3686 36 14.241 35.9567 14.1469 35.8795C14.0528 35.8024 14 35.6978 14 35.5887V13.4113C14 13.3022 14.0528 13.1976 14.1469 13.1205C14.241 13.0433 14.3686 13 14.5016 13C14.6347 13 14.7623 13.0433 14.8563 13.1205C14.9504 13.1976 15.0033 13.3022 15.0033 13.4113V35.1774H52.4984C52.6314 35.1774 52.759 35.2207 52.8531 35.2979C52.9472 35.375 53 35.4796 53 35.5887C53 35.6978 52.9472 35.8024 52.8531 35.8795C52.759 35.9567 52.6314 36 52.4984 36Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27C23.5523 27 24 26.5523 24 26C24 25.4477 23.5523 25 23 25C22.4477 25 22 25.4477 22 26C22 26.5523 22.4477 27 23 27Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4004 24.6C34.9527 24.6 35.4004 24.1523 35.4004 23.6C35.4004 23.0477 34.9527 22.6 34.4004 22.6C33.8481 22.6 33.4004 23.0477 33.4004 23.6C33.4004 24.1523 33.8481 24.6 34.4004 24.6Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M23 27C23.5523 27 24 26.5523 24 26C24 25.4477 23.5523 25 23 25C22.4477 25 22 25.4477 22 26C22 26.5523 22.4477 27 23 27Z",
    fill: "#8F6767"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M34.4004 24.6C34.9527 24.6 35.4004 24.1523 35.4004 23.6C35.4004 23.0477 34.9527 22.6 34.4004 22.6C33.8481 22.6 33.4004 23.0477 33.4004 23.6C33.4004 24.1523 33.8481 24.6 34.4004 24.6Z",
    fill: "#8F6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1754 53.2083C33.1754 53.2083 32.7524 56.2889 32 57H36C36 57 34.703 55.7073 34.8246 53L33.1754 53.2083Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M33.1754 53.2083C33.1754 53.2083 32.7524 56.2889 32 57H36C36 57 34.703 55.7073 34.8246 53L33.1754 53.2083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0786 50.2896C32.0786 50.2896 31.9106 53.7739 34.1998 53.9914C36.4891 54.2088 35.943 50.2418 35.943 50.2418C35.943 50.2418 36.0691 48.287 34.7219 48.091C33.3747 47.8951 31.6045 47.7875 32.0786 50.2896Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7025 50.7658C32.7025 50.7658 30.8433 50.5025 31.0107 51.0292C31.178 51.5559 30.9316 52.2774 33 51.8903L32.7025 50.7658Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8672 50.8109C35.8672 50.8109 36.8338 50.4661 36.7989 50.9924C36.7639 51.5187 36.9512 52.2109 35.7998 51.9387L35.8672 50.8109Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8857 64.9161C17.8857 64.9161 9.02225 62.8322 11.4076 55.3476C13.7929 47.8631 19.8931 42 19.8931 42L22.5 44.1307C22.5 44.1307 15.9175 54.2971 17.9796 56.8706C20.0417 59.4442 25.9255 56.6517 27.4583 60.2315C28.9912 63.8114 27.706 68.0261 17.8857 64.9161Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 41.8152C19.7 41.8152 22.8823 37.3446 23.5546 38.0822C24.2268 38.8197 22.3508 40.7494 22.3508 40.7494C22.3508 40.7494 24.9729 42.2522 22.0885 44L19.7 41.8152Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 62.9749L17.9039 57C17.9039 57 19.4345 57.8991 22.3219 57.8003C25.2094 57.7015 27.309 58.5413 27.8755 61.0804C28.4419 63.6196 27.6989 71.8669 12 62.9749Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M12 62.9749L17.9039 57C17.9039 57 19.4345 57.8991 22.3219 57.8003C25.2094 57.7015 27.309 58.5413 27.8755 61.0804C28.4419 63.6196 27.6989 71.8669 12 62.9749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1173 64.9161C49.1173 64.9161 57.9792 62.8322 55.5917 55.3476C53.2042 47.8631 47.1077 42 47.1077 42L44.5013 44.1307C44.5013 44.1307 51.0799 54.2971 49.0182 56.8706C46.9565 59.4442 41.0738 56.6517 39.5412 60.2315C38.0086 63.8114 39.2962 68.0261 49.1173 64.9161Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1 42.0152C47.1 42.0152 43.9175 37.5446 43.2453 38.2822C42.5731 39.0197 44.4515 40.9494 44.4515 40.9494C44.4515 40.9494 41.8293 42.4522 44.7138 44.2L47.1 42.0152Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 62.9749L49.0951 57C49.0951 57 47.5668 57.8991 44.6763 57.8003C41.7858 57.7015 39.6884 58.5413 39.1245 61.0804C38.5606 63.6196 39.2852 71.8669 55 62.9749Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M55 62.9749L49.0951 57C49.0951 57 47.5668 57.8991 44.6763 57.8003C41.7858 57.7015 39.6884 58.5413 39.1245 61.0804C38.5606 63.6196 39.2852 71.8669 55 62.9749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7489 72.2189C22.6749 69.9396 22.0787 67.4471 22 64.9077C22 64.7145 22 64.5187 22 64.3255C22.015 60.803 22.9344 56.3745 27.4491 56.2309C34.9719 55.9907 44.4385 55.0167 45.7676 60.179C47.0968 65.3412 42.2898 77.8694 42.2898 77.8694L26.4397 78L23.7489 72.2189Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.147 51C32.147 51 32.6187 50.4413 32.9725 49.1276C32.9725 49.1276 36.1774 49.7584 37 47.9754C37 47.9754 36.0477 48.2634 34.9538 47.4291C33.86 46.5947 29.4905 46.6096 31.5396 50.9056L32.147 51Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2134 48.8C36.2134 48.8 37.0071 50.2987 35.9527 50.8L35.5 48.8H36.2134Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M22.2611 62C22.2611 62 23.9467 73.2646 31.49 74.1438C39.0333 75.023 45 70.7234 45 70.7234L42.6022 77.8733L26.522 78L23.5766 71.8964C23.5766 71.8964 21.232 66.8849 22.2611 62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6199 43.9854L19.65 41.5414L18.77 42.6004L21.7398 45.0443L22.6199 43.9854Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 18.5,
    r: 1.5,
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7995,
    y: 26.3785,
    width: 7.65156,
    height: 0.617978,
    transform: "rotate(-60.5 40.7995 26.3785)",
    fill: "#68E1FD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 64C15.8792 64 2 50.1208 2 33H0C0 51.2254 14.7746 66 33 66V64ZM64 33C64 50.1208 50.1208 64 33 64V66C51.2254 66 66 51.2254 66 33H64ZM33 2C50.1208 2 64 15.8792 64 33H66C66 14.7746 51.2254 0 33 0V2ZM33 0C14.7746 0 0 14.7746 0 33H2C2 15.8792 15.8792 2 33 2V0Z",
    fill: "#E6EBEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 33C1 15.3269 15.3269 1 33 1V1C50.6731 1 65 15.3269 65 33V33C65 50.6731 50.6731 65 33 65V65C15.3269 65 1 50.6731 1 33V33Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngeneers);
export default __webpack_public_path__ + "static/media/Engeneers.5b8afe3a.svg";
export { ForwardRef as ReactComponent };